<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-22 17:17:18
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-27 10:17:06
-->
<template>
  <v-card>
    <mrc_ess_skeleton_loader
      :loading="$store.state.uuid ? skeletonloading : false"
    >
      <v-card-text>
        <v-card-subtitle class="px-0 pt-0 pb-4">
          <div class="is_flex_between mx-10 text--secondary">
            <v-sheet class="d-flex align-center text--secondary">
              <span class="px-1">{{ $t("label_product") }}</span
              >/<span class="px-1">{{ $t("label_The_module") }}</span
              >/
              <span class="d-flex align-center px-1 text--secondary">
                <mrc_ess_svgIcon
                  style="font-size: 24px; margin-right: 5px"
                  icon-class="diamond02"
                ></mrc_ess_svgIcon
                >{{ $t("label_function") }} </span
              >/
              <span class="d-flex align-center px-1 text--secondary">
                <mrc_ess_svgIcon
                  style="font-size: 24px; margin-right: 5px"
                  icon-class="mouseButton"
                ></mrc_ess_svgIcon>
                {{ $t("label_button") }}
              </span>
            </v-sheet>
            <span class="mr-12">{{ $t("label_clientType") }}</span>
          </div>
        </v-card-subtitle>
        <v-treeview
          item-key="uuid"
          selectable
          v-model="uuidslist3"
          return-object
          item-children="sub"
          selected-color="primary"
          style="
            border-top: 1px solid #e8e8e8;
            border-left: 1px solid #e8e8e8;
            border-right: 1px solid #e8e8e8;
            border-radius: 4px;
          "
          expand-icon="arrow_drop_down"
          :items="treeList"
          item-disabled="disabled"
        >
          <template v-slot:label="{ item }">
            <div
              v-if="disabled"
              style="
                position: absolute;
                z-index: 10;
                width: 100%;
                height: 50%;
                margin-left: -30px;
              "
            ></div>
            <mrc_ess_svgIcon
              style="font-size: 24px; margin-right: 5px"
              icon-class="diamond02"
              v-if="item.type == 3"
            ></mrc_ess_svgIcon>
            <mrc_ess_svgIcon
              style="
                font-size: 24px;
                margin-right: 5px;
                color: rgba(0, 0, 0, 0.6);
              "
              icon-class="mouseButton"
              fill="rgba(0, 0, 0, 0.6)"
              v-if="item.type == 4"
            ></mrc_ess_svgIcon>
            {{ INT(item.names) }}
          </template>
          <template v-slot:append="{ item }">
            <div class="pr-8 d-flex" v-if="item.type != 1">
              <template v-for="item1 in splitINT(item.client_type_uuid)">
                <mrc_ess_svgIcon
                  :key="item1"
                  style="font-size: 24px; margin-right: 5px"
                  :icon-class="item1"
                ></mrc_ess_svgIcon>
              </template>
              <template
                v-for="(item1, index) in 5 -
                splitINT(item.client_type_uuid).length"
              >
                <i
                  style="font-size: 24px; margin-right: 5px; line-height: 44px"
                  class="material-icons text--secondary"
                  :key="index"
                  >maximize</i
                >
              </template>
            </div>
          </template>
        </v-treeview>
      </v-card-text>
      <!-- <button @click="success">success</button> -->
      <slot name="submitBtn"> </slot>
    </mrc_ess_skeleton_loader>
  </v-card>
</template>

<script>
import { updatequanxian, getTreeList } from "@/service/api/clientmanage_api.js";

export default {
  components: {},
  props: {
    uuidslist: {
      //用户选中的按钮
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    uuidslist3: [],
    originaluuids: [],
    skeletonloading: true,
    oldtree: [], //老数据 用户一开始的数据
    function_permission: [
      //功能权限 用户实时选中的数据
    ],
    delete_function_buttons: [], //删除数据
    uuids: [],
    isload: false,
    treeList: [], //完整的树
    id: 0, //标识数量
    deleteArr: [], //删除的uuid
  }),
  computed: {
    uuidslist2() {
      let arr = [];
      this.uuidslist.map((item) => {
        item.button_uuid.forEach((item1) => {
          arr.push({ uuid: item1 });
        });
      });
      return arr;
    },
  },
  mounted() {
    this.uuidslist.map((item) => {
      item.button_uuid.forEach((item1) => {
        this.uuidslist3.push({
          uuid: item1,
          uuid1: item.function_uuid,
          detailUuid: item.uuid,
          Nochange: "Nochange",
        });
        this.originaluuids.push({ uuid: item1, detailUuid: item.uuid });
      });
    });
    // this.uuidslist.map(item => {
    //   item.button_uuid.forEach(item1 => {
    //     this.uuidslist3.push(item1)
    //   })
    // })
  },
  watch: {},
  methods: {
    success() {
      //权限逻辑处理
      // console.log(this.uuidslist3, this.uuidslist3.length, this.id);
      if (this.uuidslist3.length <= 0)
        return { delete_uuid_arr: [], button_uuid_arr: [], NoButton: true };
      let idArr = [],
        delete_uuid_arr = []; //删除的按钮合集
      let numArr = this.uuidslist3.map((item) => {
        return item.logo;
      });
      if (this.uuidslist3[0].type) {
        for (let i = 0; i < this.id; i++) {
          if (!numArr.includes(i)) idArr.push(i);
        }
        idArr.forEach((item) => {
          this.findidItem(this.treeList, item, "logo");
        });
        // console.log(idArr);
        // console.log(idArr, this.deleteArr);
        //相同uuid1的按钮合并   删除的按钮
        var delArr = this.$clone(this.deleteArr);
        var obj = {};
        for (var i = 0; i < delArr.length; i++) {
          var ai = delArr[i];
          if (!obj[ai.uuid1]) {
            delete_uuid_arr.push({
              client_type_uuid: ai.client_type_uuid,
              logo: ai.logo,
              names: ai.names,
              type: ai.type,
              uuid: ai.uuid,
              uuid1: ai.uuid1,
            });
            obj[ai.uuid1] = ai;
          } else {
            for (var j = 0; j < delete_uuid_arr.length; j++) {
              var dj = delete_uuid_arr[j];
              if (dj.uuid1 == ai.uuid1) {
                dj.uuid = dj.uuid + "," + ai.uuid;
                break;
              }
            }
          }
        }
      }
      this.deleteArr = []; //清空删除buttin_uuid列表
      // console.log(delete_uuid_arr);
      //相同uuid1的按钮合并 新增的按钮
      var arr = this.$clone(this.uuidslist3).filter((item) => {
        return !item.logo && item.logo !== 0 && item.Nochange != "Nochange";
      });
      // console.log(arr);
      var map = {},
        button_uuid_arr = [];
      for (var i = 0; i < arr.length; i++) {
        var ai = arr[i];
        if (!map[ai.uuid1]) {
          button_uuid_arr.push({
            client_type_uuid: ai.client_type_uuid,
            logo: ai.logo,
            names: ai.names,
            type: ai.type,
            uuid: ai.uuid,
            uuid1: ai.uuid1,
            detailUuid: ai.detailUuid,
          });
          map[ai.uuid1] = ai;
        } else {
          for (var j = 0; j < button_uuid_arr.length; j++) {
            var dj = button_uuid_arr[j];
            if (dj.uuid1 == ai.uuid1) {
              dj.uuid = dj.uuid + "," + ai.uuid;
              ai.detailUuid ? (dj.detailUuid = ai.detailUuid) : "";
              break;
            }
          }
        }
      }
      // console.log(button_uuid_arr);
      // return { delete_uuid_arr: [], button_uuid_arr: [] }
      return { delete_uuid_arr, button_uuid_arr, NoButton: false };
    },
    getchangeref() {
      return this.$refs.reftree.getCheckData();
    },
    getData(v) {
      //获取最新的选择列表
      this.function_permission = v;
    },
    typedelmethods(oldarr, newarr, comparisonvalue) {
      //加typedel方法
      var result = []; //
      for (var i = 0; i < oldarr.length; i++) {
        var c_value = oldarr[i].comparisonvalue;
        var isExist = false;
        for (let j = 0; j < newarr.length; j++) {
          if (newarr[j].comparisonvalue == c_value) {
            isExist = true;
            break;
          }
        }
        if (!isExist) {
          result.push({ ...oldarr[i], "~type~": "del" });
        }
      }
      return result;
    },
    async gettreelist() {
      //获取默认tree树
      this.skeletonloading = true;
      if (this.$store.state.uuid) {
        const listtree = await getTreeList({
          client_role_uuid: this.$store.state.uuid,
        });
        this.treeList = listtree.data;
        this.originaluuids.forEach((item) => {
          this.addlogo(this.treeList, item.uuid, "uuid", item.detailUuid);
        });
      } else {
        const listtree = await getTreeList();
        this.treeList = listtree.data;
        this.originaluuids.forEach((item) => {
          this.addlogo(this.treeList, item.uuid, "uuid", item.detailUuid);
        });
      }
      this.skeletonloading = false;
    },
    addlogo(arr, uuid, key = "uuid", detailUuid) {
      //递归给树添加标识
      if (Array.isArray(arr) && arr.length > 0) {
        arr.forEach((item) => {
          if (item[key] == uuid) {
            item.logo = this.id;
            item.detailUuid = detailUuid;
            this.id++;
            return;
          } else {
            if (Array.isArray(item.sub) && arr.length > 0) {
              this.addlogo(item.sub, uuid, key, detailUuid);
            }
          }
        });
      }
    },
    findidItem(arr, uuid, key = "uuid") {
      //
      if (Array.isArray(arr) && arr.length > 0) {
        arr.forEach((item) => {
          if (item[key] == uuid) {
            this.deleteArr.push(item);
          } else {
            if (Array.isArray(item.sub) && arr.length > 0) {
              this.findidItem(item.sub, uuid, key);
            }
          }
        });
      }
    },
  },
  async created() {
    await this.gettreelist();
    this.isload = false;
    this.isload = true;
  },
};
</script>

<style scoped>
/deep/ .v-treeview-node__root {
  border-bottom: 1px solid #e8e8e8;
}
</style>
